import { Injectable } from "@angular/core";

/**
 * 画面遷移時の一覧データ保持用
 */
@Injectable()
export class CwsPlanGoodsUseImageGrioupListService {
  imageList: [] = [];
}